module.exports = __webpack_public_path__ + "img/Savings_&_Investments.20db8e26.svg";